export const Primania = () => null;
